import React, { useState, useEffect } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import LoadingOverlay from '../../components/loading/loading';
import { toast } from "react-toastify";
import service from '../../services/service';
import authService from '../../services/authService';
import './style.css';

const SearchSection = ({ selectClass, data }) => {
    const [opinions, setOpinions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [commission, setcommission] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [commissionRate, setcommissionRate] = useState(0);
    const [bookings, setBookings] = useState(0);
    const [selectedOption, setSelectedOption] = useState("");
    const [showOptionsModal, setShowOptionsModal] = useState(false);

    const closeModal = () => setShowOptionsModal(false);

    useEffect(() => {
        getOpinions();
        getUserDetailsByID();
    }, []);


    const getOpinions = async () => {
        try {
            setLoading(true);
            const response = await service.view("opinions");
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            setOpinions(response.opinions);
            setSelectedOption(response.opinions.length > 0 ? response.opinions[0]._id : "");
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const action = e.target.getAttribute("data-action");
        try {
            if (action === "bookHotel") {
                openBookingModal();
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    const getUserDetailsByID = async () => {
        try {
            setLoading(true);
            const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
            if (isLoggedIn) {
                const userDetail = await authService.getUserDetailsById(sessionStorage.getItem("userId"));
                if (userDetail && userDetail.success) {
                    setcommissionRate(userDetail.user.commissionRate);
                    setBookings(userDetail.totalBookings);
                }
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }

    const openBookingModal = () => {
        const pricePerNight = data?.pricePerNight;
        const calculatedCommission = pricePerNight * (commissionRate / 100);
        setcommission(calculatedCommission);
        setShowModal(true);
    };

    const saveConfirmBooking = async () => {
        try {
            setLoading(true);
            if (sessionStorage.getItem("isLoggedIn") !== 'true') {
                toast.error("Please login to continue");
                return;
            }

            const formData = {
                hotel_id: data?._id,
                user_id: sessionStorage.getItem("userId"),
                opinion_id: selectedOption,
                pricePerNight: data?.pricePerNight,
                commission: commission,
                commissionRate: commissionRate,
            };

            const result = await service.save(formData, "bookings/book-hotel-review");

            if (result) {
                const { success, message } = result;
                toast[success ? 'success' : 'error'](message);
                window.location.href = "/";
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } finally {
            setLoading(false);
            setShowModal(false);
        }
    };

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    const handleConfirmBooking = () => {
        setShowOptionsModal(true);
    };

    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '30px 20px',
            backgroundColor: '#ffffff',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
        },
        formWrapper: {
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
        },
        searchSection: {
            position: 'relative',
            marginBottom: '20px',
        },
        searchInput: {
            width: '100%',
            padding: '16px 20px 16px 50px',
            fontSize: '16px',
            borderRadius: '12px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#f8f9fa',
            transition: 'all 0.3s ease',
            outline: 'none',
        },
        searchIcon: {
            position: 'absolute',
            left: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666',
            fontSize: '20px',
        },
        dropdownList: {
            position: 'absolute',
            top: 'calc(100% + 5px)',
            left: '0',
            width: '100%',
            maxHeight: '250px',
            overflowY: 'auto',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
        },
        dropdownItem: {
            padding: '15px 20px',
            borderBottom: '1px solid #f0f0f0',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
        },
        formGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px',
            marginTop: '20px',
        },
        inputGroup: {
            position: 'relative',
        },
        label: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
            color: '#666',
        },
        icon: {
            marginRight: '8px',
            fontSize: '16px',
        },
        guestSelect: {
            position: 'relative',
        },
        guestButton: {
            width: '100%',
            padding: '15px 20px',
            fontSize: '15px',
            borderRadius: '12px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
        },
        guestDropdown: {
            position: 'absolute',
            top: 'calc(100% + 5px)',
            left: '0',
            width: '100%',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            padding: '20px',
            zIndex: 1000,
        },
        guestControl: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            padding: '10px 0',
            borderBottom: '1px solid #f0f0f0',
        },
        controlButtons: {
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
        },
        controlButton: {
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            fontSize: '18px',
            color: '#666',
        },
        guestCount: {
            fontSize: '16px',
            fontWeight: '500',
            minWidth: '30px',
            textAlign: 'center',
        },
        dateInput: {
            width: '100%',
            padding: '15px 20px',
            fontSize: '15px',
            borderRadius: '12px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#f8f9fa',
            cursor: 'pointer',
        },
        submitButton: {
            width: '100%',
            padding: '16px',
            fontSize: '16px',
            fontWeight: '500',
            color: '#fff',
            backgroundColor: '#2563eb',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
            marginTop: '20px',
        },
        bookButton: {
            backgroundColor: '#16a34a',
        },
        chevron: {
            fontSize: '12px',
            transition: 'transform 0.2s ease',
        },
        subText: {
            fontSize: '13px',
            color: '#666',
            marginTop: '4px',
        }
    };

    return (
        <div className={`wpo-select-section ${selectClass}`}>
            {loading && <LoadingOverlay />}
            <div style={styles.container}>
                <button type="button" style={{ ...styles.submitButton, ...styles.bookButton }} onClick={handleFormSubmit} data-action="bookHotel">
                    Book Now
                </button>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div
                        className="modal-container"
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            className="modal-close"
                            onClick={() => setShowModal(false)}
                        >
                            ×
                        </button>

                        <div className="modal-header">
                            <h2>Booking Confirmation</h2>
                        </div>

                        <div className="modal-body">
                            <div className="price-item">
                                <span>Bookings Count</span>
                                <span className="price">{(Number(bookings) || 0)}</span>
                            </div>
                            <div className="price-item">
                                <span>Hotel</span>
                                <span className="price">{data?.name}</span>
                            </div>
                            <div className="price-item">
                                <span>Price</span>
                                <span className="price">₹ {(Number(data?.pricePerNight) || 0).toFixed(2)}</span>
                            </div>
                            <div className="price-item">
                                <span>Commission ({commissionRate}%)</span>
                                <span className="price">₹ {commission?.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn-secondary"
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn-primary"
                                onClick={handleConfirmBooking}
                            >
                                Confirm Booking
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showOptionsModal && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>×</button>
                        <div className="modal-header" style={{ color: "#317afa" }}>
                            <h2>Share Your Opinion</h2>
                        </div>
                        <div className="modal-body">
                            <label>Please select at least one</label>
                            {opinions.length > 0 ? (
                                opinions.map((option, index) => (
                                    <div key={index}>
                                        <label>
                                            <input
                                                type="radio"
                                                name="option"
                                                value={option._id}
                                                checked={selectedOption === option._id}
                                                onChange={handleOptionChange}
                                            />
                                            &nbsp;{option.opinions.join(", ")}
                                        </label>
                                    </div>
                                ))
                            ) : (
                                <p>No opinions available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn-secondary" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="btn-primary" onClick={saveConfirmBooking}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchSection;
